import { Box, CircularProgress, Modal, Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type PaymentProgressModalProps = {
  open: boolean
}
export const PaymentProgressModal: Organism<PaymentProgressModalProps> = ({
  open,
}) => {
  const { t } = useTranslation('paymentProgress')
  return (
    <Modal open={open}>
      <Box
        id="modal-inner"
        sx={{
          width: 280,
          borderRadius: 3,
          px: 5,
          py: 7,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'grey.100',
          outline: 'none',
          textAlign: 'center',
        }}
      >
        <Stack alignItems="center" spacing={4}>
          <CircularProgress size={28} />
          <Typography variant="h5" sx={{ pb: 3 }}>
            {t('paymentProgressTitle')}
          </Typography>
        </Stack>
        <Typography variant="body2">{t('paymentProgressDesc')}</Typography>
      </Box>
    </Modal>
  )
}
